
import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputReusable } from '../input-reusable/input-reusable';

@Component({
  selector: 'app-input-test',
  standalone: true,
  imports: [ReactiveFormsModule, InputReusable],
  templateUrl: './input-test.html',
  styleUrl: './input-test.css',
})
export class InputTest {
  readonly showcaseLgText = new FormControl('', { nonNullable: true });
  readonly showcaseLgEmail = new FormControl('', { nonNullable: true });
  readonly showcaseLgPassword = new FormControl('', { nonNullable: true });

  readonly showcaseMdText = new FormControl('', { nonNullable: true });
  readonly showcaseMdEmail = new FormControl('', { nonNullable: true });
  readonly showcaseMdPassword = new FormControl('', { nonNullable: true });

  readonly form = new FormGroup({
    text: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.minLength(3), Validators.maxLength(25)],
    }),
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    password: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.minLength(8)],
    }),
    number: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.pattern(/^[-]?\d*\.?\d+$/)],
    }),
    search: new FormControl('Mortgage options', { nonNullable: true }),
    tel: new FormControl('', {
      nonNullable: true,
      validators: [Validators.pattern(/^[0-9+\s()-]{8,20}$/)],
    }),
    url: new FormControl('', {
      nonNullable: true,
      validators: [Validators.pattern(/^https?:\/\/.+/)],
    }),
    date: new FormControl('', { nonNullable: true }),
    time: new FormControl('', { nonNullable: true }),
    textarea: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.minLength(10), Validators.maxLength(160)],
    }),
    readonlyExample: new FormControl('Readonly preset value', { nonNullable: true }),
    disabledExample: new FormControl({ value: 'Disabled preset value', disabled: true }, { nonNullable: true }),
  });

  get submittedJson(): string {
    return JSON.stringify(this.form.getRawValue(), null, 2);
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
  }

  reset(): void {
    this.form.reset({
      text: '',
      email: '',
      password: '',
      number: '',
      search: 'Mortgage options',
      tel: '',
      url: '',
      date: '',
      time: '',
      textarea: '',
      readonlyExample: 'Readonly preset value',
      disabledExample: { value: 'Disabled preset value', disabled: true },
    });
  }

}
